export default __webpack_public_path__ + "static/media/products_banner_1.6278276b.jpg";